<template>
  <div class="container-filho" >
    <Titulo :title="titulo" />
    <VideosCarousel :secaoVideos="secaoVideos" />
    <div style="width:100%; margin-top: 20px;">
      <MiniCardAcao :texto="textoMiniCard" :router="'/videos'" />
    </div>
  </div>
</template>

<script>
import Titulo from './Titulo.vue'
import VideosCarousel from './VideosCarousel.vue'
import FirebaseHelper from "@/service/FirebaseHelper";
import MiniCardAcao from './MiniCardAcao.vue'

export default {
  name: 'VideosCardHome',
  components: {
    Titulo,
    VideosCarousel,
    MiniCardAcao
  },
  props: {
    titulo: ""
  },
  data() {
    return {
      secaoVideos: [],
      firebaseHelper: new FirebaseHelper(),
      textoMiniCard: `Quer assistir mais conteúdo do ${this.titulo.replace('<br>',' ')}? Clique aqui!`
    }
  },
  async created() {
    this.secaoVideos = await this.firebaseHelper.getVideos('videosCardHome')
  }
}
</script>
